module.exports = __webpack_public_path__ + "img/India.fff0aaed.png";